import api from '../api/api'

export const GET_SIGNATURE_REQUEST_BEGIN = 'GET_SIGNATURE_REQUEST_BEGIN'
export const GET_SIGNATURE_REQUEST_SUCCESS = 'GET_SIGNATURE_REQUEST_SUCCESS'
export const GET_SIGNATURE_REQUEST_FAILURE = 'GET_SIGNATURE_REQUEST_FAILURE'

export const UPDATE_SIGNATURE_REQUEST_BEGIN = 'PATCH_SIGNATURE_REQUEST_BEGIN'
export const UPDATE_SIGNATURE_REQUEST_SUCCESS = 'PATCH_SIGNATURE_REQUEST_SUCCESS'
export const UPDATE_SIGNATURE_REQUEST_FAILURE = 'PATCH_SIGNATURE_REQUEST_FAILURE'

export const SET_AGREED_DOCUMENTS = 'SET_AGREED_DOCUMENTS'

export const GET_PAGES_BEGIN = 'GET_PAGES_BEGIN'
export const GET_PAGES_SUCCESS = 'GET_PAGES_SUCCESS'
export const GET_PAGES_FAILURE = 'GET_PAGES_FAILURE'

export const GET_EXPIRE_PAGE_BEGIN = 'GET_EXPIRE_PAGE_BEGIN'
export const GET_EXPIRE_PAGE_SUCCESS = 'GET_EXPIRE_PAGE_SUCCESS'
export const GET_EXPIRE_PAGE_FAILURE = 'GET_EXPIRE_PAGE_FAILURE'

// Get Signature Request
export const getSignatureRequestBegin = () => ({
  type: GET_SIGNATURE_REQUEST_BEGIN,
})

export const getSignatureRequestFailure = (error) => ({
  type: GET_SIGNATURE_REQUEST_FAILURE,
  payload: { error },
})

export const getSignatureRequestSuccess = (data) => ({
  type: GET_SIGNATURE_REQUEST_SUCCESS,
  payload: { data },
})

// Update Signature Request
export const updateSignatureRequestBegin = () => ({
  type: UPDATE_SIGNATURE_REQUEST_BEGIN,
})

export const updateSignatureRequestFailure = (error) => ({
  type: UPDATE_SIGNATURE_REQUEST_FAILURE,
  payload: { error },
})

export const updateSignatureRequestSuccess = () => ({
  type: UPDATE_SIGNATURE_REQUEST_SUCCESS,
  payload: {},
})

// Set Agreed Documents
export const setAgreedDocuments = (idDoc) => {
  return {
    type: SET_AGREED_DOCUMENTS,
    payload: idDoc,
  }
}

// Get Pages
export const getPagesBegin = () => ({
  type: GET_PAGES_BEGIN,
})

export const getPagesFailure = (error) => ({
  type: GET_PAGES_FAILURE,
  payload: { error },
})

export const getPagesSuccess = (data) => ({
  type: GET_PAGES_SUCCESS,
  payload: { data },
})

export const getPages = () => {
  return (dispatch) => {
    dispatch(getPagesBegin())
    api
      .getPages()
      .then((response) => {
        return dispatch(getPagesSuccess(response.data))
      })
      .catch((error) => dispatch(getPagesFailure(error)))
  }
}

export const getSignatureRequest = () => {
  return (dispatch) => {
    dispatch(getSignatureRequestBegin())
    api
      .getSignatureRequest()
      .then((response) => dispatch(getSignatureRequestSuccess(response.data)))
      .catch((error) => dispatch(getSignatureRequestFailure(error)))
  }
}

export const updateSignatureRequest = (data) => {
  return (dispatch) => {
    dispatch(updateSignatureRequestBegin())
    api
      .patchSignatureRequest(data)
      .then((response) => {
        api
          .getSignatureRequest()
          .then((response) => {
            dispatch(getSignatureRequestSuccess(response.data))
            dispatch(updateSignatureRequestSuccess())
          })
          .catch((error) => dispatch(getSignatureRequestFailure(error)))
      })
      .catch((error) => dispatch(updateSignatureRequestFailure(error)))
  }
}

// Get Pages
export const getExpirePageBegin = () => ({
  type: GET_EXPIRE_PAGE_BEGIN,
})

export const getExpirePageFailure = (error) => ({
  type: GET_EXPIRE_PAGE_FAILURE,
  payload: { error },
})

export const getExpirePageSuccess = (data) => ({
  type: GET_EXPIRE_PAGE_SUCCESS,
  payload: { data },
})

export const getExpirePage = () => {
  return (dispatch) => {
    dispatch(getExpirePageBegin())
    api
      .getExpirePage()
      .then((response) => {
        return dispatch(getExpirePageSuccess(response.data))
      })
      .catch((error) => dispatch(getExpirePageFailure(error)))
  }
}
